<template>
    <div class="headerd" style="min-width: 1300px">
        <!--<span class="footer" @click="returnTop">123</span>-->
        <div class="header_con" style="position: relative">
            <div style="float: left;">
                <img class="logo" src="../assets/img/logo.png" alt="">
            </div>
            <div style="float: left">
                <img class="shu" src="../assets/img/形状4.png" alt="">
            </div>
            <span>彩虹律师旗下高端服务</span>
            <div class="rightDiv" style="float: right;position: absolute;right: 100px;top: 0;">
                <span @click="homePage">首页</span>
                <span @click="serviceM">服务模块</span>
                <span @click="lawyerS">律师风采</span>
                <span @click="serviceS">服务范围</span>
                <span @click="lecture">法律讲座</span>
                <span @click="serviceP">服务套餐</span>
                <span @click="about">关于我们</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "headerd",
        data(){
            return{
                i:0
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll, true);
        },
        methods:{
            handleScroll(){
                // 页面滚动距顶部距离
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop
                var scroll = scrollTop - this.i;
                // console.log(scroll);
                this.i = scrollTop;

                if(scrollTop == 0){
                    let headerd = document.querySelector(".header_con");
                    headerd.style.backgroundColor = "transparent";
                }
                if(scroll<0){
                    // console.log('up')
                    let headerd = document.querySelector(".header_con");
                }else{
                    // console.log('down')
                    let headerd = document.querySelector(".header_con");
                    headerd.style.backgroundColor = "rgb(40,43,47)";
                }
            },
            homePage(){
                document.querySelector(".banner").scrollIntoView(true);
                // console.log("首页")
            },
            serviceM(){
                document.querySelector(".serviceM").scrollIntoView(true);
                // console.log("服务模块")
            },
            lawyerS(){
                document.querySelector(".lawyerS").scrollIntoView(true);
                // console.log("律师风采")
            },
            serviceS(){
                document.querySelector(".serviceS").scrollIntoView(true);
                // console.log("服务范围")
            },
            lecture(){
                document.querySelector(".lectureS").scrollIntoView(true);
                // console.log("法律讲座")
            },
            serviceP(){
                document.querySelector(".serviceP").scrollIntoView(true);
                // console.log("服务套餐")
            },
            about(){
                document.querySelector(".aboutA").scrollIntoView(true);
                // console.log("关于我们")
            }

        }
    }
</script>

<style lang="less" scoped>
    .headerd{
        width: 100%;
        .header_con{
            opacity: 1;
            height: 70px;
            width: 100%;

            .logo{
                width: 177px;
                height: 50px;
                padding-top: 3px;
                margin-left: 60px;
            }
            .shu{
                width: 1px;
                height: 30px;
                padding-left: 20px;
               position: absolute;
                top: 20px;
            }
            span{
                line-height: 70px;
                margin-left: 40px;
                font-size: 16px;
                color: white;
            }
            .rightDiv{
                span{
                    cursor:pointer;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/headerd.vue